import { createContext, useContext, useEffect, useState } from 'react';

export const ConsultationContext = createContext({
  setChildData: () => { },
});

const PatientContext = createContext()

export const PatientProvider = ({ children }) => {

  const [patientType, setPatientType] = useState(() => {
    return localStorage.getItem('patientType') || '';
  });

  useEffect(() => {
    localStorage.setItem('patientType', patientType);
  }, [patientType]);

  return (
    <PatientContext.Provider value={{ patientType, setPatientType }}>
      {children}
    </PatientContext.Provider>
  )
}

export const usePatientTypeContext = () => useContext(PatientContext)